import moment from "moment";
import { apiSlice } from "../../app/services/apiSlice";
import uniqBy from "lodash/uniqBy";

const EVENTS_URL = 'events';


export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTeamListing: builder.mutation({
            query: (params) => ({
                url: `accounts`,
                params,
            }),
            transformResponse: (responseData) => {
                responseData.options =uniqBy(responseData?.accounts?.map((team) => ({
                    ...team,
                })),'id') ;
                return responseData || {};
            },
        }),
        getCandidatesList: builder.mutation({
            query: (params) => ({
                url: `applications/list`,
                params,
            }),
            transformResponse: (responseData) => {
                responseData.options = responseData?.data;
                return responseData || {};
            },
        }),
        addNewEvent: builder.mutation({
            query: (data) => ({
                url: `${EVENTS_URL}`,
                method: 'POST',
                body: {
                    ...data,
                },
            }),
            invalidatesTags: [{ type: 'Event', id: 'LIST' }],
        }),
        updateEvents: builder.mutation({
            query: (data) => ({
                url: `${EVENTS_URL}/${data.id}`,
                method: 'PUT',
                body: {
                    ...data,
                },
            }),
            invalidatesTags: [{ type: 'Event', id: 'LIST' }],
        }),
        removeEvents: builder.mutation({
            query: (id) => ({
                url: `${EVENTS_URL}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Event', id: 'LIST' }],
        }),
        getAllEvents: builder.query({
            query: (params) => ({
                url: `${EVENTS_URL}`,
                params,
            }),
            providesTags: [{ type: 'Event', id: 'LIST' }],
        }),
        getDashboardEvents: builder.query({
            query: (params) => ({
                url: `dashboard/upcoming-events?minDate=${moment().set({ minute: 0, second: 0, millisecond: 0 }).toISOString()}`,
                params,
            })
        }),
        getIdBasedEvents: builder.mutation({
            query: (id) => ({
                url: `${EVENTS_URL}/${id}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useAddNewEventMutation,
    useGetAllEventsQuery,
    useGetDashboardEventsQuery,
    useRemoveEventsMutation,
    useUpdateEventsMutation,
    useGetTeamListingMutation,
    useGetIdBasedEventsMutation,
    useGetCandidatesListMutation
} = extendedApiSlice;
